import { MediaType } from '@atom/types/media';

export const ROOT_FOLDER_ID = 'root';

export const ROOT_FOLDER_LABEL = 'All Files';

export const MEDIA_TYPE_LABELS: Record<MediaType, string> = {
  [MediaType.DOCUMENT]: 'Documents',
  [MediaType.IMAGE]: 'Photos',
  [MediaType.VIDEO]: 'Videos',
  [MediaType.REPORT]: 'Reports',
};
